<div class="activities"></div>